import { useState, useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import QuantityControl from './QuantityControl';
import SectionGrid from '@shared/components/SectionGrid';

const GroupedButtons = ({
  defaultValue,
  value,
  minValue,
  maxValue,
  label,
  roomInfo,
  total,
  totalLimit,
}) => {
  const [counter, setCounter] = useState(defaultValue);
  const theme = useTheme();

  useEffect(() => {
    if (defaultValue !== counter) setCounter(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    value(counter);
  }, [counter]);

  const handleIncrement = () => setCounter(counter + 1);
  const handleDecrement = () => setCounter(counter - 1);

  return (
    <SectionGrid
      padding={1}
      spacing={0}
      gridSx={{ paddingLeft: '0px' }}
      customLayout={{
        md: {
          1: 7,
          2: 5,
        },
      }}
    >
      <Box sx={{ mb: 0.5 }}>
        <Typography variant="subtitle1" sx={{ lineHeight: 1.3 }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: 14, color: '#000', lineHeight: 1.3 }}>
          {label === 'Adultos' ? 'A partir de 18 años' : 'Hasta 17 años'}
        </Typography>
      </Box>
      <QuantityControl
        {...{
          theme,
          counter,
          minValue,
          handleDecrement,
          label,
          maxValue,
          handleIncrement,
          roomInfo,
          total,
          totalLimit,
        }}
      />
    </SectionGrid>
  );
};

export default GroupedButtons;
